<template>
	<div>
		<div class="flex justify-between mt-1">
			<div>
				<!-- todo si on edit: modifie la langue, sinon on demande à stepV2 de chercher la version -->
				<select
					:disabled="editing"
					class="bg-transparent border-none outline-none"
					style="color: var(--theme-text-color)"
					v-model="lang">
					<option
						style="background: var(--theme-background-color)"
						v-for="(language, i) in languageOptions"
						:key="language.value + '-' + i"
						:value="language.value">
						{{ language.text }}
					</option>
				</select>
			</div>
			<!-- * si le user est admin (rules === null) -->
			<div
				class=""
				v-show="
                    isAdmin
				">
				<button
					style="color: var(--theme-text-color)"
					class="text-xl hover:opacity-80 hover:shadow-md"
					@click="() => toggleEdit()">
					<i v-if="!editing" style="" class="fas fa-edit"></i>
					<i v-if="editing" style="" class="fas fa-save"></i>
				</button>
			</div>
		</div>
		<div v-if="!editing && Object.keys(stepInformation).length > 0">
			<div class="text-center">
				<h1>{{ title }}</h1>
				<div>
					{{ description }}
				</div>
			</div>
			<div class="mt-4" v-html="info"></div>
		</div>
		<div v-show="editing">
			<div class="text-center">
				<input
					style="color: var(--theme-text-color)"
					v-model="title"
					class="leading-[1.2] mb-[0.5rem] font-medium outline-none border-x-0 border-t-0 border-b-2 border-b-black bg-transparent text-center text-[2.5rem]" />
				<br />
				<textarea
					style="color: var(--theme-text-color)"
					v-model="description"
					rows="6"
					class="w-50 shadow-none outline-none border-x-0 border-t-0 border-b-2 border-b-black bg-transparent text-center">
				</textarea>
			</div>
			<div class="w-[100%] h-[500px] inline-block relative mt-4">
				<pre
					class="w-[100%] h-[100%]"
					:id="
						'html_editor-' + id + '-' + actionGroupDesignation
					"></pre>
			</div>

			<div class="mt-2">
				Preview:
				<div
					class="border-solid border-2 border-black rounded-sm"
					v-html="info"></div>
			</div>
		</div>
		<div
			class="text-center"
			v-show="!editing && Object.keys(stepInformation).length === 0">
			Informations non disponibles en cette langue.
		</div>
	</div>
</template>

<script>
	import store from "../store.js";
	var clone = require("clone");
	import uniqueId from "lodash.uniqueid";

	export default {
		name: "step-info-editor",
		props: {
			stepInformation: {
				type: Object,
				default: null,
				required: true,
			},
			id: {
				default: uniqueId(""),
			},
			actionGroupDesignation: {
				default: "",
			},
		},
		data() {
			return {
				languageOptions: [
					{
						value: "EN",
						text: "English",
					},
					{
						value: "FR",
						text: "Français",
					},
				],

				info: "<h1>Html du tutoriel</h1>",
				title: "Titre du tutoriel",
				description: "Description",
				lang: "FR",
				user: null,
				editing: false,

				editorRef: null,
			};
		},
        computed: {
            isAdmin: function() {
                return store.getters.isAdmin;
            }
        },
		methods: {
			toggleEdit() {
				if (this.editing) {
					this.save();
				} else {
					this.editorRef.setValue(this.info, -1);

					this.editing = true;
				}
			},
			save() {
				// * emit event, and call put service
				this.$emit(
					"save",
					this.title,
					this.description,
					this.info,
					this.lang
				);
				this.editing = false;
			},
		},
		watch: {
			lang: {
				handler: function (newVal, oldVal) {
					if (!this.editing) {
						// * ask stepV2 to get the step information
						this.$emit("get-step-info", this.lang);
					}
				},
			},
			stepInformation: {
				handler: function (newVal, oldVal) {
					// console.log("Step information change: ", clone(newVal));
					// * ne touchons pas à this.lang, cf le watcher au dessus
					if (Object.keys(newVal).length > 0) {
						this.title = newVal.title;
						this.description = newVal.description;
						this.info = newVal.info;
						// this.lang = newVal.lang;
					} else {
						this.info = "<h1>Html du tutoriel</h1>";
						this.title = "Titre du tutoriel";
						this.description = "Description";
						// this.lang = "FR";
					}
				},
			},
		},
		created() {},
		async mounted() {
			this.user = store.state.user;

			var ace_editor = ace.edit(
				"html_editor-" + this.id + "-" + this.actionGroupDesignation
			);
			// console.log("Created ace editor", ace_editor);
			this.editorRef = ace_editor;
			ace_editor.session.setMode("ace/mode/html");
			var theme = "chrome";
			if (
				store &&
				store.state &&
				store.state.style &&
				store.state.style.theme &&
				store.state.style.theme.code
			)
				theme = store.state.style.theme.code;
			ace_editor.setTheme("ace/theme/" + theme);
			// enable autocompletion and snippets
			ace_editor.setOptions({
				enableBasicAutocompletion: true,
				enableSnippets: true,
				enableLiveAutocompletion: true,
			});

			var self = this;
			ace_editor.session.on("change", function () {
				self.info = ace_editor.getValue();
			});

			// console.log("Just got created: ", clone(this.stepInformation));
			if (
				this.stepInformation !== null &&
				Object.keys(this.stepInformation).length > 0
			) {
				this.title = this.stepInformation.title;
				this.description = this.stepInformation.description;
				this.info = this.stepInformation.info;
				this.lang = this.stepInformation.lang;
				// this.lang = this.languageOptions.find(langOpt => langOpt.value === this.stepInformation.lang);
			}
			// console.log("Setting ace editor value: ", this.info);
			ace_editor.setValue(this.info, -1);
		},
	};
</script>
